import { useEffect } from 'react';
import { getConsentPreferences } from './CookieConsent';

/**
 * Manages loading of tracking scripts based on user consent
 * Respects GDPR and CCPA preferences stored in localStorage
 */
const ConsentAwareScripts = () => {
  useEffect(() => {
    const consent = getConsentPreferences();
    
    // If no consent given yet, don't load any optional scripts
    if (!consent) {
      console.log('[Consent] No consent preferences found, waiting for user choice');
      return;
    }

    // Load Google Analytics if analytics consent given
    if (consent.analytics) {
      loadGoogleAnalytics();
    } else {
      console.log('[Consent] Analytics cookies rejected');
      // Disable GA if it was previously loaded
      if (typeof window !== 'undefined') {
        (window as any)['ga-disable-G-9T7GKQ8BK7'] = true;
      }
    }

    // Load AdSense if advertising consent given
    if (consent.advertising) {
      loadGoogleAdSense();
    } else {
      console.log('[Consent] Advertising cookies rejected');
    }
  }, []);

  return null;
};

function loadGoogleAnalytics() {
  // Check if already loaded
  if (document.querySelector('script[src*="googletagmanager.com/gtag"]')) {
    console.log('[Consent] Google Analytics already loaded');
    return;
  }

  console.log('[Consent] Loading Google Analytics');
  
  // The GA script is in index.html, but we can signal it's okay to track
  if (typeof window !== 'undefined' && (window as any).gtag) {
    // Update consent mode
    (window as any).gtag('consent', 'update', {
      analytics_storage: 'granted',
    });
  }
}

function loadGoogleAdSense() {
  // Check if already loaded
  if (document.querySelector('script[src*="pagead2.googlesyndication.com"]')) {
    console.log('[Consent] Google AdSense already loaded');
    return;
  }

  console.log('[Consent] Loading Google AdSense');
  
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5057458522036537';
  script.crossOrigin = 'anonymous';
  script.setAttribute('data-consent-script', 'adsense');
  document.head.appendChild(script);
}

export default ConsentAwareScripts;
